export default "__VITE_ASSET___uyqmIxX__"